export default "__VITE_ASSET__XrbxxIB4__"